import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_PROJECT_CAMPAIGN, GET_PROJECT_CAMPAIGN_SUCCESS, GET_PROJECT_CAMPAIGN_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getProjectCampaign({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    // const { membershipId, benefitConfigId,page_size, page_index } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/campaigns/projects`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROJECT_CAMPAIGN_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROJECT_CAMPAIGN_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROJECT_CAMPAIGN_ERROR, payload: error });
  }
}

export function* watchGetProjectCampaign() {
  yield takeEvery(GET_PROJECT_CAMPAIGN, getProjectCampaign);
}

function* getProjectCampaignSaga() {
  yield all([fork(watchGetProjectCampaign)]);
}

export default getProjectCampaignSaga;
